import React, { useEffect, useState, useCallback } from "react"
import {
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap"

import { Link } from "react-router-dom"
import { Field as AvField, Form as AvForm } from "@availity/form"
import axios from "axios"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"
import { ethers } from "ethers"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"
import erc20Abi from "../../abi/MyERC20.json"
import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import { formatNumber, avgGasPrice } from "../../utils"
import { useToast } from "../../hooks/toast"
import { addWhitelistedContract } from "./paymasterUtils"

import paymasterAbi from "../../abi/ERC721Paymaster.json"

const paymasterContract = "0x14086A82F6Ffb6e4b3bddE5ea844F053bEC5143D" //alt

const PaymasterAdmin = () => {
    const web3 = new Web3(window.ethereum)

    const [isLoading, setIsLoading] = useState(false)
    const [chainId, setChainId] = useState(undefined)
    const [account, setAccount] = useState(0)

    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [txModal, setTxModal] = useState(false)
    const [tx, setTx] = useState({
        status: "",
        hash: ""
    })

    const [processing, setProcessing] = useState(false)
    const [whitelistedContract, setWhitelistedContract] = useState("0x739307dc5c36B7Fd4d7B42c533c9408c2c565F35")

    const [network, setNetwork] = useState("zksync")

    const toast = useToast()
    const wallet = useWallet()

    const handleTx = (status, hash) => {
        setTx({ status: status, hash: hash })
    }

    const handleResetForm = async () => {
        window.location.reload()
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        console.log(event)
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const handleSetContract = async () => {
        web3.setProvider(wallet.ethereum.provider)
        setProcessing(true)
        //method on contract is mintNFT, doesn't take any input
        // console.log("name: " + name + " description: " + description + " image: " + JSON.stringify(selectedFiles[0]) + " attribute: " + JSON.stringify(attributes))
        // const imageFile = selectedFiles[0].base64
        // //get the token uri from current set data (name, description, image, attributes)
        // // setProcessing(true)
        // const tokenUriA = await uploadNFTMetadata(key, imageFile, name, description, attributes)
        // const tokenUriB = tokenUriA.data.data.metadata_uri
        // console.log('token uri response: ' + JSON.stringify(tokenUriA.data))
        // console.log('token uri: ' + tokenUriB)

        // const tokenUri = "dummyfornow"

        addWhitelistedContract(web3, paymasterAbi, paymasterContract, wallet.account, whitelistedContract, setProcessing, setMessage, handleResetForm)
    }

    const handleTxModal = (type) => {
        switch (type) {
            case "open":
                setTxModal(true)
                break
            case "close":
                setTxModal(false)
                setTx("", "")
                break

            default:
                break
        }
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                    setChainId(wallet.chainId)
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    return (
        <React.Fragment>
            <div className="content">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <CardTitle className="h4">Add Destination Contract</CardTitle>
                                <p className="card-title-desc">Provide an address</p>

                                <AvForm initialValues={{ whitelistedContract: "" }} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup className="mb-3">
                                                <AvField
                                                    name="whitelistedContract"
                                                    label="ContractToWhitelist"
                                                    placeholder="Enter Contract Address"
                                                    type="text"
                                                    onChange={(e) => setWhitelistedContract(e.target.value)}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm="6"></Col>
                                    </Row>
                                    <div className="d-flex flex-wrap gap-2">
                                        <Button
                                            className="btn submit-btn w-100 blue-btn text-uppercase"
                                            onClick={() => handleSetContract()}
                                            style={{ width: "100%" }}
                                        >
                                            {!processing ? "Add Contract " : "Processing... "}
                                            {processing ? <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" /> : null}
                                        </Button>
                                    </div>
                                </AvForm>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default PaymasterAdmin
